import { useCallback, useRef, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import MediaService from '../../services/MediaService';
import UnitNavigation from '../../components/Navigation/UnitNavigation';
import Surprise from '../../components/World/Surprise/Surprise';
import { GetUserVideo, getVideo } from '../../s3Func/s3Download';

const Module20Nav = () => {
  const { module20 } = useSelector((state) => state.module20, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  /*****************
   *  BG Image Logic
   * ***************/

  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseConfig, setSurpriseConfig] = useState(null);
  const bgImage = useRef();

  const checkScreenSize = () => {
    const desktopImage =
      '/Module20Images/JourneyMap20-01.png';
    const mobileImage =
      '/Module20Images/JourneyMap20-01_phone.png';

    bgImage.current =
      window.screen && window.screen.width < 1025 ? mobileImage : desktopImage;
  };

  const resizeListener = useCallback(() => {
    window.addEventListener(
      'resize',
      (event) => checkScreenSize(event.target),
      true
    );
  }, []);

  resizeListener();
  checkScreenSize();

  const backgroundPath =
    bgImage.current && MediaService.getImage(bgImage.current, login);
  const worldBG = MediaService.getImage(
    '/Module20Images/Unit4_Mod5BG-01.png',
    login
  );

  /*****************
   *  Day Logic
   * ***************/

  const getDayConfig = useCallback((dayNumber) => {
    const filledImageUrl = `/Module10Images/Module10NavImages/JourneyMap_Mod5_Day${dayNumber}.png`;
    const outlinedImageUrl = `/Module10Images/Module10NavImages/JourneyMap_Mod5_Outline_Day${dayNumber}.png`;

    return {
      dayNumber,
      destiny: '/caring',
      filledImageUrl,
      outlinedImageUrl,
    };
  }, []);

  const daysArray = [...Array(8).keys()];
  const DAYS_CONFIG = daysArray.map((index) => getDayConfig(index + 1));

  const SURPRISE_VIDEO = {
    song: 'appfiles/caring/caring_instrumental.m4a',
    slides: [
      `userfiles/${module20.StudentID}/caring_celebration_surprise_5.mp4`,
      `influencers/${login.influencerid}/close_affirmation.mp4`,
      'appfiles/caring/practice_clothing_1.mp4',
      `userfiles/${module20.StudentID}/caring_practice_1_7.mp4`,
      'appfiles/caring/practice_clothing_2.mp4',
      `userfiles/${module20.StudentID}/caring_practice_2_7.mp4`,
      'appfiles/caring/practice_clothing_3.mp4',
      `userfiles/${module20.StudentID}/caring_practice_3_7.mp4`,
      'appfiles/caring/practice_clothing_4.mp4',
      `userfiles/${module20.StudentID}/caring_practice_4_7.mp4`,
      `influencers/${login.influencerid3}/conversation_affirmation.mp4`,
      `userfiles/${module20.StudentID}/caring_celebration_surprise_6.mp4`,
      `influencers/${login.influencerid1}/close_affirmation.mp4`,
      `userfiles/${module20.StudentID}/caring_celebration_surprise_7.mp4`,
      `influencers/${login.influencerid2}/close_affirmation.mp4`,
      `userfiles/${module20.StudentID}/caring_celebration_surprise_8.mp4`,
      `influencers/${login.influencerid2}/close_affirmation.mp4`,
      `userfiles/${module20.StudentID}/caring_celebration_surprise_9.mp4`,
    ],
  };

  const handleSurpriseClick = async () => {
    let { slides, song, video } = SURPRISE_VIDEO;

    slides = await Promise.all(
      slides.map(async (url) => await GetUserVideo(url, login))
    );
    song = await getVideo(song, login);

    setSurpriseConfig({ video, slides, song });
    setDisplaySurprise(true);
  };

  /*****************************
   *  Component configuration
   * ***************************/

  return (
    <>
      {displaySurprise && (
        <Surprise
          background={worldBG}
          setDisplaySurprise={setDisplaySurprise}
          video={surpriseConfig.video}
          song={surpriseConfig.song}
          slides={surpriseConfig.slides}
          onSurpriseEnded={() => setDisplaySurprise(false)}
        />
      )}

      {backgroundPath && (
        <UnitNavigation
          moduleName='MODULE20'
          module={module20}
          days={DAYS_CONFIG}
          totalDays={8}
          unitDestiny='/unit4'
          nextDestiny='/unitPage'
          backgroundPath={backgroundPath}
          onSurpriseClick={handleSurpriseClick}
          unit={4}
          animal={MediaService.getImage('/Images/Button_BirdHead.png', login)}
        />
      )}
    </>
  );
};
export default Module20Nav;
